/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable max-len */
import {
  Autocomplete, Box, Popper, TextField,
} from '@mui/material';
import React, {
  useContext, useMemo,
} from 'react';
import ListboxComponent from 'Shared/Header/AdapaterReactWindow';
import ReferencialContext from 'Shared/ReferencialContext';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useStyles from './styles';

const PopperMy = (props) => <Popper {...props} style={{ width: 400 }} placement="bottom-start" />;

const Filters = ({ values, onChange }) => {
  const {
    state: { referencial },
  } = useContext(ReferencialContext);
  const { brands } = referencial;
  const families4 = useMemo(() => {
    const { families = [] } = referencial;
    return families?.filter((family) => family.familyLevel === 4);
  }, [referencial.families]);
  const classes = useStyles();
  const handleInputChange = (name, value) => {
    onChange({ target: { name, value } });
  };

  return (
    <Box className={classes.filterContainer} sx={{ mb: 3 }}>
      <Box className={classes.filterZone}>
        <TextField
          variant="outlined"
          onChange={onChange}
          value={values?.search}
          label="chercher"
          size="small"
          name="search"
          className={classes.filter}
          style={{ width: 200 }}
          InputProps={{
            classes: { notchedOutline: classes.notched },
          }}
          InputLabelProps={{
            classes: { root: classes.label },
          }}
        />
        <Autocomplete
          PopperComponent={PopperMy}
          classes={{ root: classes.filter }}
          options={brands || []}
          onChange={(event, value) => handleInputChange('brand', value)}
          value={values?.brand}
          size="small"
          getOptionLabel={(option) => option.name}
          ListboxComponent={ListboxComponent}
          multiple
          filterOptions={(options, v) => options.filter((option) => option.name?.toLowerCase().includes(v.inputValue.toLowerCase()))}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Marques"
              variant="outlined"
              inputProps={{
                ...params.inputProps,
                autoComplete: 'new-password', // disable autocomplete and autofill
              }}
                // eslint-disable-next-line react/jsx-no-duplicate-props
              InputProps={{
                ...params.InputProps,
                classes: { notchedOutline: classes.notched },
              }}
              InputLabelProps={{
                classes: { root: classes.label },
              }}
            />
          )}
          popupIcon={<ExpandMoreIcon style={{ color: '#000' }} />}
        />
        <Autocomplete
          PopperComponent={PopperMy}
          classes={{ root: classes.filter }}
          options={families4 || []}
          onChange={(event, value) => handleInputChange('family4', value)}
          value={values?.family4}
          size="small"
          autoHighlight
          getOptionLabel={(option) => option.name}
          ListboxComponent={ListboxComponent}
          multiple
          filterOptions={(options, v) => options.filter((option) => option.name?.toLowerCase().includes(v.inputValue.toLowerCase()))}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Familles"
              variant="outlined"
              inputProps={{
                ...params.inputProps,
                autoComplete: 'new-password', // disable autocomplete and autofill
              }}
              InputProps={{
                ...params.InputProps,
                classes: { notchedOutline: classes.notched },
              }}
              InputLabelProps={{
                classes: { root: classes.label },
              }}
            />
          )}
          popupIcon={<ExpandMoreIcon style={{ color: '#000' }} />}
        />
      </Box>
    </Box>
  );
};

export default Filters;
